/* eslint-disable no-underscore-dangle */
import React from 'react';
import Chip from '@material-ui/core/Chip';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import CardBody from '../../sharedComponents/Card/CardBody';
import { useStyles } from './styles';

const WordsList = ({ words, pageWords, handleChangeLimit }) => {
  const classes = useStyles();

  return (
    <>
      <InputLabel id="select-label">Número de palabras</InputLabel>
      <Select
        labelId="customized-select-label"
        id="demo-customized-select"
        value={pageWords}
        onChange={(event) => handleChangeLimit(event)}
        // input={<BootstrapInput />}
      >
        <MenuItem value={50}>50</MenuItem>
        <MenuItem value={100}>100</MenuItem>
        <MenuItem value={200}>200</MenuItem>
        <MenuItem value={300}>300</MenuItem>
      </Select>
      <div className={classes.rootChips}>
        <CardBody className={classes.cardBody}>
          {words.response?.length > 0 ? (
            words.response.map((item) => (
              <div key={item?._id}>
                <Chip
                  id={item?._id}
                  label={`${item?._id?.toUpperCase()} Total: ${item?.total}`}
                  clickable
                  className={classes.chip}
                  color="primary"
                />
              </div>
            ))
          ) : (
            <>
              <span>No existe nube de palabras para este análisis</span>
            </>
          )}
        </CardBody>
      </div>
    </>
  );
};

export default WordsList;
